import Section from 'modules/InquiryDetails/DetailedInformation/DetailedInformationSection';
import { AnyFields } from 'new/form/state/types';
import { usePortalConfig } from 'new/portals/state/portalConfigContext/hooks';
import { SummaryPageField } from 'new/summary/hooks/useBuildFieldsForSummary';
import { useBuildFieldsForPortalDetails } from 'pages/customerPortal/InquiryDetails/DetailedInformation/InquiryDetails/useBuildFieldsForPortalDetails';
import { GridWithDivider } from 'pages/customerPortal/InquiryDetails/DetailedInformation/mittweida/components/GridWithDivider';
import { useTranslations } from 'utils/hooks/useTranslations';

interface InquiryDetailsSummaryProps {
  fields: AnyFields;
}

export const InquiryDetailsSummary = ({ fields }: InquiryDetailsSummaryProps) => {
  const { portalConfig } = usePortalConfig();
  const t = useTranslations();
  const pagesWithFieldCaptionAndValue = useBuildFieldsForPortalDetails({
    summaryFields: portalConfig?.summaryFields,
    stepSequence: portalConfig?.stepSequence,
    fields,
  });

  if (!portalConfig) {
    return null;
  }

  return (
    <>
      {Object.keys(pagesWithFieldCaptionAndValue).map((pageName) => {
        const fields: Array<SummaryPageField> = (pagesWithFieldCaptionAndValue as any)[pageName];
        return (
          <Section
            title={t((portalConfig.stepData as any)[pageName].progressBarTitle)}
            key={pageName}
          >
            <GridWithDivider fields={fields} />
          </Section>
        );
      })}
    </>
  );
};
